// --- Dependencies -------------------------------------------------------------------------------
import type { ReactNode } from "react";
// --- Our Modules --------------------------------------------------------------------------------
import "./styles.css";

// --- Types --------------------------------------------------------------------------------------

type Props = {
    label: string;
    badge?: string;
    children: ReactNode;
};

// --- Logic --------------------------------------------------------------------------------------

/**
 * Gives controls that are not MUI inputs — image pickers, segmented choices — the same notched
 * outline the text fields have, so every row in a form reads as one family. A real fieldset/legend
 * cuts the border natively instead of faking it with a background swatch.
 */
export default function OutlinedField({ label, badge, children }: Props) {
    return (
        <fieldset className="outlined-field">
            <legend className="outlined-field-legend">
                {label}
                {badge && <span className="outlined-field-badge">{badge}</span>}
            </legend>
            <div className="outlined-field-body">{children}</div>
        </fieldset>
    );
}
